import React, { useState } from 'react';
import axios from 'axios'; // Import axios for HTTP requests
import './ContactPage.css'; // Import the CSS file for styling
import TopMenuBar from '../components/TopMenuBar';
import { FaPhone, FaEnvelope } from 'react-icons/fa'; // Import icons from react-icons

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    additionalDetail: '',
  });

  const [statusMessage, setStatusMessage] = useState('');
  const [statusClass, setStatusClass] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!formData.email.includes('@')) {
    setStatusMessage('Please enter a valid email address.');
    setStatusClass('error-message');
    return;
  }
  setIsSubmitting(true);
  try {
    const response = await axios.post('/api/contact-form', {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        message: formData.message,
        additional_detail: formData.additionalDetail,
      });
      setStatusMessage('Your message has been sent successfully!');
      setStatusClass('success-message');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
        additionalDetail: '',
      });
    } catch (error) {
    console.error('Error sending message:', error);
    setStatusMessage('Failed to send your message. Please try again later.');
    setStatusClass('error-message');
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <>
      <TopMenuBar />
      <div className="contact-page">
        <div className="form-section">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="additionalDetail">Additional Details</label>
              <textarea
                id="additionalDetail"
                rows="2"
                value={formData.additionalDetail}
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="send-button" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
          {statusMessage && <p className={statusClass}>{statusMessage}</p>}
        </div>
        <div className="info-section">
          <h1>Get In Touch With Us</h1>
          <p>Feel free to reach us through this form or contact us with the options below:</p>
          <div className="contact-info">

          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <a href="mailto:info@souspal.com">info@souspal.com</a>
          </div>

          </div>
        </div>
      </div>
    </>
  );
};
